<template>
  <div class="container-download-options position-relative">
    <UiButton
      color="green"
      class="download-btn"
      min-width="164"
      min-height="45"
      height="45"
      :to="actualVector.urlDownload"
      blank="true"
      @click.native="openEditOnline"
    >
      <span class="d-flex align-items-center">
        {{ $t('main.preview.content.editOnline') }}
        <img src="https://cdn.vexels.com/img/cursor-click.png" alt="Edit Online" class="ml-2" />
      </span>
    </UiButton>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import UiButton from '@/components/UI/Button';

export default {
  name: 'EditOnlineBtn',
  components: {
    UiButton
  },
  computed: {
    ...mapState('vectors', ['actualVector'])
  },
  methods: {
    openEditOnline() {
      this.gaEvent('edit_online');
    },
    gaEvent(type) {
      this.$dataLayerPush('click_download_button', {
        download: {
          type
        }
      });
    }
  }
};
</script>
<style lang="scss">
#preview-vector-modal .container-download-options .download-btn > .vexels-button {
  @include md {
    width: 100% !important;
  }
}
</style>

<style lang="scss" scoped>
.download-icon-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  margin-left: 8px;
  transform: scale(0.8);
}
.download-icon-floor {
  width: 16px;
  height: 2px;
  background-color: white;
  border-radius: 2px;
}
@keyframes bounce {
  0%,
  10%,
  40%,
  70%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(-4px);
  }
}
.container-download-options {
  display: flex;
  justify-content: flex-end;
  height: max-content;
  margin-left: auto;
  &:hover .icon-arrow-svg {
    animation-name: bounce;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
  @include md {
    width: 100%;
  }
  .download-btn {
    display: flex;
    align-items: center;
    &.link {
      color: white;
      background-color: #3cd699;
      height: 45px;
      min-width: 164px;
      min-height: 45px;
      font-size: 15px;
      cursor: pointer;
      border-radius: 23px;
      color: white;
      padding-right: 28px;
      padding-left: 28px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    &.secondary {
      border: 1.5px solid #3dd699;
      background-color: white;
      color: #3dd699;
      &:hover {
        background-color: #3dd699;
        color: white;
        border: none;
      }
    }
  }
  .seasonal-image {
    max-height: 45px;
  }
}
button {
  background-color: #3cd699;
  border: none;
  outline: none;
  color: #fff;
}
button:disabled {
  background-color: #d2d2d2 !important;
  border-color: #d2d2d2 !important;
  cursor: not-allowed !important;
}
button:disabled:hover {
  filter: none !important;
}
</style>
